<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-doubledown`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.0296 8.41574C11.2893 8.15637 11.7114 8.15631 11.971 8.41574C12.2306 8.67534 12.2304 9.09742 11.971 9.35714L8.82453 12.5026C8.36957 12.9576 7.63105 12.9576 7.17609 12.5026L4.0296 9.35714L3.94464 9.25265C3.77434 8.99454 3.80242 8.64292 4.0296 8.41574C4.25684 8.18876 4.6085 8.16045 4.86652 8.33077L4.97101 8.41574L8.00031 11.445L11.0296 8.41574ZM11.0296 3.1423C11.2893 2.88293 11.7114 2.88288 11.971 3.1423C12.2306 3.40191 12.2304 3.82398 11.971 4.0837L8.82453 7.22921C8.36957 7.68417 7.63105 7.68417 7.17609 7.22921L4.0296 4.0837L3.94464 3.97921C3.77434 3.72111 3.80242 3.36948 4.0296 3.1423C4.25684 2.91532 4.6085 2.88701 4.86652 3.05734L4.97101 3.1423L8.00031 6.1716L11.0296 3.1423Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineDoubledown',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
